/**
 * @file useTaskRole.js
 * @description Custom hook to retrieve the current user's task management system role and helper flags.
 */

import { GetUserPrivilages } from "../firebase/UserPrivilageProvider";

/**
 * Custom hook to get current user's task management system role.
 * @returns {{taskRole: string, isTaskUser: boolean, isTaskAdmin: boolean}}
 *
 * isTaskUser — true for TaskUser AND TaskAdmin (shared TMS access)
 * isTaskAdmin — true only for TaskAdmin (exclusive access to dashboard & labels report)
 */
export function useTaskRole() {
  const privileges = GetUserPrivilages();
  const loading = privileges?.loading ?? true;
  // Use ?? so that an empty string "" (revoked role) is NOT treated as missing
  const taskRole = privileges?.taskRole ?? "TaskUser";

  return {
    loading,
    taskRole,
    isTaskUser: taskRole === "TaskUser" || taskRole === "TaskAdmin",
    isTaskAdmin: taskRole === "TaskAdmin",
  };
}
